const events = {
    FUNNEL_STEP_COMPLETE: "gaCustomEvent_FunnelStepComplete",
    START_QUOTE: "gaCustomEvent_StartQuote",
    START_QUOTE_SUBMIT: "quote_submission",
};

export default events;
